// src/components/TermList.js
import React from 'react';
import TermItem from './TermItem';

const TermList = ({ terms, onTermClick }) => {
  if (terms.length === 0) {
    return <p className="text-center text-gray-500 mt-8">該当する用語はありません。</p>;
  }

  return (
    <div className="mt-6">
      {terms.map(term => (
        <TermItem key={term.id} term={term} onTermClick={onTermClick} />
      ))}
    </div>
  );
};

export default TermList;